import { Tag } from "antd";
import { UseWaterRegisterStatus } from "../enums/global.enums";
import { CSSProperties } from "react";
import { getUseWaterRegisterStatusDisplay } from "../enums/global.enums";

export function useWaterRegisterStatusPipe(value: string) {
    return getUseWaterRegisterStatusDisplay(value);
}

export function useWaterRegisterStatusTagPipe(value?: string, style?: CSSProperties) {
    switch (value) {
        case UseWaterRegisterStatus.New: 
            return <Tag color="blue" style={style}>{getUseWaterRegisterStatusDisplay(value || "")}</Tag>;
        case UseWaterRegisterStatus.InProcess: 
            return <Tag color="orange" style={style}>{getUseWaterRegisterStatusDisplay(value || "")}</Tag>;
        case UseWaterRegisterStatus.Completed: 
            return <Tag color="green" style={style}>{getUseWaterRegisterStatusDisplay(value || "")}</Tag>;
        case UseWaterRegisterStatus.Rejected: 
            return <Tag color="red" style={style}>{getUseWaterRegisterStatusDisplay(value || "")}</Tag>;
        default: 
            return <Tag color="default" style={style}>{getUseWaterRegisterStatusDisplay(value || "")}</Tag>;
    }
}

